if (!customElements.get("custom-product-card")) {
  customElements.define(
    "custom-product-card",
    class customProductCard extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // 缓存常用元素
        this.colorSwatchContainer = this.querySelector(".card_product-card__swatch");
        this.targetInput = this.querySelector('[data-type="add-to-cart-form"] [name="id"]');
        this.swatchItems = this.querySelectorAll(".color-swatch-item");
        this.imageContainer = this.querySelector(".custom-product-card__image");
        this.imageList = this.querySelector(".color_swatch_image_list");
        this.priceContainer = this.querySelector(".custom-product-card__price");

        if (!this.colorSwatchContainer || !this.targetInput) return;

        // 桌面端交互
        this.colorSwatchContainer.addEventListener("mouseover", this.handleSwatchInteraction.bind(this));
        // 移动端交互
        this.colorSwatchContainer.addEventListener("touchstart", this.handleSwatchInteraction.bind(this), { passive: false });
      }

      /** 事件处理入口 */
      handleSwatchInteraction(event) {
        event.preventDefault();
        const swatchItem = event.target.closest(".color-swatch-item");
        if (!swatchItem) return;

        // 🔹 如果已经是 active，直接跳过，避免性能消耗
        if (swatchItem.classList.contains("active")) return;

        const variantId = swatchItem.dataset.id;

        this.updateVariantInput(variantId);
        this.updateActiveSwatch(swatchItem);
        this.updateImage(variantId);
        this.updatePrice(swatchItem);
      }

      /** 更新表单 variantId */
      updateVariantInput(variantId) {
        this.targetInput.value = variantId;
      }

      /** 更新色卡高亮 */
      updateActiveSwatch(activeItem) {
        this.swatchItems.forEach(item =>
          item.classList.toggle("active", item === activeItem)
        );
      }

      /** 更新图片 */
      updateImage(variantId) {
        if (!this.imageList || this.imageList.children.length === 0 || !this.imageContainer) return;

        this.imageContainer.classList.add("active");
        this.imageContainer
          .querySelectorAll(".color_swatch_image__item")
          .forEach(img => img.classList.toggle("active", img.dataset.id === variantId));
      }

      /** 更新价格信息 */
      updatePrice(swatchItem) {
        if (!this.priceContainer) return;

        const newPrice = swatchItem.dataset.price || "";
        const newCompareAtPrice = swatchItem.dataset.compareAtPrice || "";

        if (this.isValidComparePrice(newCompareAtPrice)) {
          // 有对比价 -> 打折
          this.priceContainer.classList.add("price--on-sale");
          this.priceContainer
            .querySelector(".price__sale .price-item.price-item--regular")
            .textContent = newPrice;
          this.priceContainer
            .querySelector(".price__sale .price-item.price-item--sale.price-item--last")
            .textContent = newCompareAtPrice;
        } else {
          // 无对比价 -> 非打折
          this.priceContainer.classList.remove("price--on-sale");
          this.priceContainer
            .querySelector(".price__regular .price-item.price-item--regular")
            .textContent = newPrice;
        }
      }

      /** 判断 compareAtPrice 是否有效 */
      isValidComparePrice(value) {
        return value !== "" && value !== "null" && value !== "undefined";
      }
    }
  );
}
